import React, { useState, useEffect } from "react";
import Card from "../../../components/Card";
import { Row, Col, Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import { getApiCall, patchApiCall } from "../../../service/httpCall";
import { API_VOICE_PLAN_EDIT, API_VOICE_PLAN_GET_BY_ID } from "../../../service/url";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../utilities/constant";
import RenderVoicePlanForm from "./_form";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { getUser } from "../../../utilities/setting";
import { DeleteIcon } from '../../../components/setting/elements';

export default function VoicePlanEdit() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { checkAuth } = useAuth();

    const [planName, setPlanName] = useState("");
    const [planType, setPlanType] = useState("");
    const [pulseDuration, setPulseDuration] = useState("0");
    const [pulsePrice, setPulsePrice] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [userPulseDuration, setUserPulseDuration] = useState(null);
    const [userPulsePrice, setUserPulsePrice] = useState(Infinity);
    const [plansData, setPlansData] = useState([]);
    const [currentPlan, setCurrentPlan] = useState([]);
    const [planNameError, setPlanNameError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuth(setToastProps, setShowToast);
    }, []);


    useEffect(() => {
        const user = getUser();
        if (user?.voice_plan_id) {
            setUserPulseDuration(user.voice_plan_id.pulse_duration);
            setUserPulsePrice(user.voice_plan_id.price);
        }


        getApiCall(`${API_VOICE_PLAN_GET_BY_ID}/${id}`)
            .then((resp) => {
                setPlanName(resp.plan_name);


                setPlansData(resp.plans);


                setCurrentPlan(resp.plans.map(p => p.plan_type));
            })
            .catch((err) => {
                toast.error("Failed to load plan data");
                console.error(err);
            })
            .finally(() => setLoading(false));
    }, [id]);

    function validateForm() {
        let valid = true;
        if (!planName) {
            valid = false;
            toast.warning("Plan Name required");
        } else if (plansData.length === 0) {
            valid = false;
            toast.warning("Plan Data required");
        } else {
            for (let i = 0; i < plansData.length; i++) {
                const plan = plansData[i];
                if (plan.pulse_price !== undefined && plan.pulse_price !== null) {
                    const priceStr = plan.pulse_price.toString();
                    const decimalParts = priceStr.split('.');
                    if (decimalParts.length > 1 && decimalParts[1].length > 2) {
                        valid = false;
                        toast.warning(`Price at row ${i + 1} must have maximum 2 decimal places`);
                        break;
                    }
                }
            }
        }
        return valid;
    }

    function submitForm(e) {
        e.preventDefault();
        setButtonDisable(true);

        if (!validateForm()) {
            setButtonDisable(false);
            return;
        }

        const normalizedPlans = plansData.map(plan => ({
            ...plan,
            pulse_price: typeof plan.pulse_price === 'string'
                ? parseFloat(plan.pulse_price)
                : Number(plan.pulse_price),
            pulse_duration: typeof plan.pulse_duration === 'string'
                ? parseInt(plan.pulse_duration, 10)
                : Number(plan.pulse_duration),
        }));

        const params = {
            plan_name: planName,
            plans: normalizedPlans,
        };


        patchApiCall(`${API_VOICE_PLAN_EDIT}/${id}`, params)
            .then(() => {
                toast.success("Voice plan updated successfully");
                setTimeout(() => {
                    navigate(`/${ROUTES.VOICE_PLAN.LIST}`);
                }, 1500);
            })
            .catch((err) => {
                if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
                    errorCheck(err, navigate, setToastProps, setShowToast);
                }
                setButtonDisable(false);
                toast.warning(err);
            });
    }

    const handleRemovePlan = (data) => {
        setPlansData(prev => prev.filter(plan => plan.plan_type !== data.plan_type));
        setCurrentPlan(prev => prev.filter(plan => plan !== data.plan_type));
    };

    if (loading) return <div>Loading...</div>;

    return (
        <>
            <div>
                <Row>
                    <Col xl="12" lg="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Edit Voice Plan</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <form onSubmit={async (e) => { submitForm(e); }}>
                                    <RenderVoicePlanForm
                                        planName={planName}
                                        setPlanName={setPlanName}
                                        pulseDuration={pulseDuration}
                                        setPulseDuration={setPulseDuration}
                                        pulsePrice={pulsePrice}
                                        setPulsePrice={setPulsePrice}
                                        setUserPulsePrice={setUserPulsePrice}
                                        userPulsePrice={userPulsePrice}
                                        userPulseDuration={userPulseDuration}
                                        setUserPulseDuration={setUserPulseDuration}
                                        setPlanType={setPlanType}
                                        planType={planType}
                                        setPlansData={setPlansData}
                                        plansData={plansData}
                                        currentPlan={currentPlan}
                                        setCurrentPlan={setCurrentPlan}
                                        setPlanNameError={setPlanNameError}
                                    />

                                    
                                    <div className="mt-4">
                                        <h5>Assigned Voice plan</h5>
                                        <table className="table table-bordered" style={{ marginTop: "20px" }}>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Plan Name</th>
                                                    <th>Plan Duration</th>
                                                    <th>Plan Price</th>
                                                    <th>Plan Type</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {plansData.length > 0 ? (
                                                    plansData.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{planName}</td>
                                                            <td>
                                                                {data.plan_type === 'MISSED' ? (
                                                                    <span style={{ color: '#adb5bd', fontStyle: 'italic' }}>N/A</span>
                                                                ) : (
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        value={data.pulse_duration}
                                                                        onChange={(e) => {
                                                                            const val = Number(e.target.value);
                                                                            setPlansData(prev =>
                                                                                prev.map((p, i) => i === index ? { ...p, pulse_duration: val } : p)
                                                                            );
                                                                        }}
                                                                        style={{ width: '80px' }}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-sm"
                                                                    value={data.pulse_price}
                                                                    onChange={(e) => {
                                                                        const val = parseFloat(e.target.value);
                                                                        setPlansData(prev =>
                                                                            prev.map((p, i) => i === index ? { ...p, pulse_price: val } : p)
                                                                        );
                                                                    }}
                                                                    style={{ width: '80px' }}
                                                                />
                                                            </td>
                                                            <td>{data.plan_type}</td>
                                                            <td>
                                                                <div className="actions" style={{ display: 'flex', gap: '5px' }}>
                                                                    <DeleteIcon
                                                                        title="Delete"
                                                                        handleCallback={() => handleRemovePlan(data)}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr><td colSpan="8" className="text-center">No Plans Found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <Button
                                        type="submit"
                                        variant="btn btn-primary"
                                        disabled={buttonDisable || plansData.length === 0 || planNameError}
                                    >
                                        Update Voice Plan &nbsp;
                                        {buttonDisable ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : <></>}
                                    </Button>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}